var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "show-hospital" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "card",
                { staticClass: "stacked-form" },
                [
                  _vm.isLoading
                    ? _c("l-progress", {
                        staticClass: "mb-2",
                        attrs: {
                          value: 100,
                          height: 20,
                          type: "info",
                          animated: true,
                          striped: true
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("fg-input", { attrs: { label: "Name" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.dataAccount.name))])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Email" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.dataAccount.email))])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Role" } }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.dataAccount.roles !== null
                                ? _vm.dataAccount.roles[0].name
                                : "-"
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5" }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "primary",
                        href: "#/profile/change-password"
                      }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "sync-alt" } }),
                      _vm._v(" Change Pasword")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("back-button")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b62a532e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b62a532e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Profile/Overview.vue
// module id = 1pEz
// module chunks = 4